import classNames from 'classnames';
import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

const LockBtn = ({
    id,
    lock,
    onLock,
    disable = false,
}: Pick<IToolLayout & ICallback, 'id' | 'lock' | 'disable' | 'onLock'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();

    return (
        <Tooltip
            placement="bottom"
            title={lock ? $t((v) => v.headerToolbar.lockBtn.unLock) : $t((v) => v.headerToolbar.lockBtn.lock)}
        >
            <div
                className={classNames('c-header-toolbar-actions-btn', {
                    lock,
                    disable,
                })}
                onClick={() => {
                    if (lock) {
                        editor.layer.unlock(id);
                    } else {
                        editor.layer.lock(id);
                    }
                    onLock?.();
                }}
            >
                <IconFont fontSize={14} name="LockBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(LockBtn);
